<!-- Componente representa la información del pie -->
<footer>
  <!-- Sección que agrupa información como logos y data general-->
  <div class="logo1">
    <img src="assets/img/logo_FondoEuropeo.svg" alt="logotipo Fondo Europeo">
  </div>
  <div class="logo2">
    <img src="assets/img/logo_PRTR.svg" alt="logotipo PRTR">
  </div>
  <div class="contactInfo">
    <span><a href="mailto:cau-servicios@sanidad.gob.es?Subject=SIPRODI"><em class="pi pi-envelope"></em>cau-servicios@sanidad.gob.es</a></span>
  </div>
  <div *ngIf="rutaActual != '/' && rutaActual != '/login' && rutaActual != '/acceder'" class="contactInfo">
    <span><small>SIPRODI Versión: {{version}}</small></span>
  </div>

</footer>
